<div class="orderStatus">
  <mat-icon [ngClass]="agParam.data.stateCode!=8 ? 'hidden':''" class="pointer" svgIcon="exclamation-mark"
    #tooltipMin="matTooltip" matTooltipPosition="above" [matTooltip]="agParam.data.text"></mat-icon>
  <span [class]="statusClass"> {{agParam.value}}</span>
</div>